import { colors } from '../../colors';
var address = {
  addressColor: colors.ash
};
export default address;